import * as React from 'react';

const RX_PLACEHOLDER = /\{(.+?)\}/g;

export const insertLink = (text: string = '', components: React.ReactNode[]) => {
  if(!text) {
    return null;
  }
  
  const split = text.split(RX_PLACEHOLDER);
  return split.map((part, index) => {
    if (!(index % 2)) {
      return part;
    }
    return React.createElement(React.Fragment, { key: index }, components[parseInt(part, 10)]);
  });
};
